import {
  getCoreRowModel,
  useReactTable,
  type TableOptions,
} from '@tanstack/react-table';
import { PartiallyOptional } from '@/shared/types/utils';

export type Props<TData> = {
  options: PartiallyOptional<TableOptions<TData>, 'getCoreRowModel'>;
};

function useTable<TData>({ options }: Props<TData>) {
  const table = useReactTable({
    ...options,
    getCoreRowModel: options.getCoreRowModel ?? getCoreRowModel(),
  });

  return table;
}

export default useTable;
